const projects = [
  {
    num: '01',
    title: 'Acoustic Intelligence',
    subtitle: 'SaMD · FDA Class II · Edge AI',
    desc: 'AI-native acoustic screening platform fusing cough audio, chest auscultation, and clinical data for early detection of TB, ILD, COPD, lung cancer, and pneumonia.',
    caps: ['Edge TinyML inference on smartphones', 'Probabilistic risk scores with explainability', 'Continuous monitoring of disease progression'],
    stack: 'PyTorch · TensorFlow Lite · TinyML · YAMNet · FastAPI · FHIR'
  },
  {
    num: '02',
    title: 'CTF Multimodal Intelligence',
    subtitle: 'Core Platform · Fusion Engine',
    desc: 'Integrates chest X-rays, acoustic biomarkers, pathology, labs, and clinical data through Concept Tuning & Fusion.',
    caps: ['Hybrid raw + semantic dual-branch fusion', 'Residual raw embedding pathways', 'Federated learning via Flower'],
    stack: 'PyTorch · MONAI · Neo4j · pgvector · Milvus · Flower · Ray'
  },
  {
    num: '03',
    title: 'Translational AI & Precision Medicine',
    subtitle: 'Biomarker Discovery · Multi-Omics',
    desc: 'High-throughput platform integrating multi-omics, digital pathology, radiology, and acoustics.',
    caps: ['Radiogenomics linking phenotypes', 'Pathology-centric vision-language models', 'Mechanism-informed patient subtyping'],
    stack: 'PyTorch · Hugging Face · Multi-Omics · MONAI · FHIR · DICOM'
  }
];

export function ThreeProjects() {
  return (
    <section className="py-20 px-4 max-w-7xl mx-auto">
      <div className="text-center max-w-3xl mx-auto mb-12">
        <div className="font-mono text-xs text-teal tracking-wider mb-2">Three Platforms · One Architecture</div>
        <h2 className="font-serif text-3xl sm:text-4xl text-ink">From acoustic signal to precision medicine</h2>
      </div>
      <div className="grid md:grid-cols-3 gap-px bg-rule border border-rule">
        {projects.map((project) => (
          <div key={project.num} className="bg-paper p-6 hover:bg-white transition-colors">
            <div className="font-mono text-xs text-inkMuted mb-2">PLATFORM {project.num}</div>
            <h3 className="font-serif text-xl text-ink mb-1">{project.title}</h3>
            <div className="text-xs font-mono text-teal mb-4">{project.subtitle}</div>
            <p className="text-sm text-inkSoft mb-4">{project.desc}</p>
            <div className="space-y-2 mb-4">
              {project.caps.map((cap, i) => (
                <div key={i} className="text-xs text-inkSoft pl-3 relative">
                  <span className="absolute left-0 text-teal">→</span> {cap}
                </div>
              ))}
            </div>
            <div className="text-[10px] font-mono text-inkMuted pt-3 border-t border-rule">{project.stack}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
